/* ============================================================
   DATA TERAPI WASIR

   Letakkan di: app/layanan/terapi-wasir/terapi-wasir.js

   ============================================================
   SUMBER ISINYA

   Nomor telepon dan kalimat "silakan hubungi nomor di bawah untuk
   melakukan reservasi" disalin dari halaman lama di
   rsjmc.id/terapi-wasir.

   Kalimat pengantarnya diambil dari layananList.terapiWasirDesc di
   dictionary.js.

   ⚠️ SELEBIHNYA TIDAK ADA. Halaman lama hanya memuat satu kalimat,
   dua nomor, satu tombol, dan satu poster. Tidak ada keterangan soal
   jadwal praktik, dokter yang menangani, biaya, atau apa yang terjadi
   saat pemeriksaan.

   ============================================================
   ⚠️ TOMBOL "KLIK UNTUK RESERVASI SEKARANG!" DI SITUS LAMA

   Sama seperti di halaman Telemedicine, saya tidak bisa melihat ke
   mana tombol itu mengarah - hanya tampilannya yang terlihat di
   tangkapan layar.

   Di halaman baru ia diarahkan ke WhatsApp Customer Service. Itu
   tebakan yang masuk akal, TAPI TETAP TEBAKAN. Kalau aslinya menuju
   platform reservasi tersendiri, isi TAUTAN_RESERVASI di bawah dengan
   alamat itu.
   ============================================================ */

/* Kosongkan (null) untuk memakai WhatsApp Customer Service. Isi
   dengan alamat lengkap kalau RS punya platform reservasi sendiri. */
export const TAUTAN_RESERVASI = null;

/* ============================================================
   POSTER

   ⚠️ PERIKSA EKSTENSINYA. Kamu menyimpannya di public/images/
   dengan nama "terapi-wasir":

     .jpg  -> "/images/terapi-wasir.jpg"
     .png  -> "/images/terapi-wasir.png"
     .webp -> "/images/terapi-wasir.webp"

   Yang tertulis harus SAMA PERSIS dengan nama berkas di disk,
   termasuk huruf besar-kecilnya. Windows tidak membedakan, server
   produksi membedakan.

   Kalau salah, halaman tidak rusak - bagian posternya disembunyikan
   sendiri.

   ============================================================
   ⚠️ POSTERNYA MENULIS "Terapi Wasir Baru/Kambuh dengan Obat"

   Kalimat itu TIDAK saya pindahkan ke teks halaman, dan ini bukan
   kehati-hatian berlebihan.

   "Dengan obat" adalah pernyataan tentang METODE PENGOBATAN. Kalau
   ditulis sebagai teks di halaman resmi, pasien membacanya sebagai
   janji bahwa wasirnya bisa ditangani tanpa operasi - dan sebagian
   pasien datang justru karena berharap menghindari operasi.

   Kenyataannya, wasir punya beberapa derajat. Yang ringan memang
   umumnya cukup dengan obat dan perubahan pola makan; yang berat
   sering memerlukan tindakan. Yang menentukan adalah dokter setelah
   memeriksa, bukan poster.

   Kalau bagian terkait membenarkan bahwa layanan ini memang berbasis
   obat - dan menjelaskan apa yang terjadi kalau derajatnya berat -
   tulis keterangannya di KETENTUAN di bawah. Itu justru keterangan
   yang paling dicari pasien wasir, dan tidak ada di halaman lama.
   ============================================================ */
export const FOTO = {
  src: "/images/terapi.png",
  alt: {
    id: "Poster layanan Terapi Wasir RS Jakarta Medical Center.",
    en: "Haemorrhoid treatment poster of Jakarta Medical Center Hospital.",
  },
};

/* ============================================================
   NOMOR

   Customer Service jadi tombol utama - sama dengan halaman lama.

   ⚠️ WHATSAPP DIDAHULUKAN, DAN DI HALAMAN INI ITU PENTING.

   Wasir termasuk keluhan yang orang malu menanyakannya. Sebagian
   pasien menunda berobat berbulan-bulan justru karena harus
   mengucapkan keluhannya lewat telepon, kepada petugas yang tidak
   dikenalnya, sering dari ruangan yang ada orang lain.

   Pesan tertulis menghilangkan hambatan itu. Nomor teleponnya tetap
   disediakan - tapi urutannya disengaja.

   Nomor hunting sengaja TIDAK diberi medan `wa`. Ia sambungan telepon
   ke operator, bukan nomor WhatsApp.
   ============================================================ */
export const TERAPI_WASIR = {
  telepon: [
    {
      label: { id: "Customer Service", en: "Customer Service" },
      tampil: "0811-901-874",
      tel: "+62811901874",
      wa: "62811901874",

      /* Pesannya sengaja TIDAK menyebut kata "wasir".

         Pesan pembuka WhatsApp muncul di kolom ketik, dan kolom itu
         terlihat siapa pun yang kebetulan melihat layar. Menyebut
         "Poliklinik Bedah" sudah cukup bagi petugas untuk mengarahkan,
         tanpa memajang keluhannya.

         Pasien tetap bisa menuliskan keluhannya sendiri kalau mau -
         WhatsApp hanya mengisi, tidak mengirim. */
      pesanWa: {
        id: "Halo RS Jakarta Medical Center,\n\nSaya ingin melakukan reservasi konsultasi di poliklinik bedah.\n\nMohon informasi jadwal dokter dan ketentuannya. Terima kasih.",
        en: "Hello RS Jakarta Medical Center,\n\nI would like to book a consultation at the surgical clinic.\n\nPlease let me know the doctor's schedule and requirements. Thank you.",
      },
      utama: true,
    },
    {
      label: { id: "Hunting", en: "Main line" },
      tampil: "(021) 798 0888",
      tel: "+62217980888",
      utama: false,
    },
  ],
};

/* ============================================================
   KETENTUAN - SENGAJA KOSONG

   Yang paling dicari pasien wasir sebelum datang, dan tidak satu pun
   ada di halaman lama:

     - hari dan jam praktik
     - dokter yang menangani, beserta spesialisasinya
     - biaya konsultasi
     - apakah semua derajat wasir bisa ditangani dengan obat, dan apa
       yang terjadi kalau tidak
     - apa yang dilakukan saat pemeriksaan pertama
     - apakah ditanggung BPJS atau asuransi

   BUTIR KEEMPAT DAN KELIMA YANG PALING MENENTUKAN. Rasa takut
   diperiksa, dan takut ujung-ujungnya dioperasi, adalah dua alasan
   terbesar orang menunda berobat wasir - sering sampai bertahun-tahun.
   Halaman yang menjawab keduanya dengan tenang lebih berguna daripada
   poster mana pun.

   Keduanya bersifat medis. Minta dokter yang menangani layanan ini
   yang menuliskannya, bukan disalin dari internet.

   Isi seperti ini, bagiannya muncul sendiri di halaman:

     { label: { id: "Jadwal praktik", en: "Clinic hours" },
       nilai: { id: "...", en: "..." } },
   ============================================================ */
export const KETENTUAN = [];

/* ============================================================
   CARA RESERVASI

   ⚠️ DRAF - BELUM DIKONFIRMASI RS.

   Halaman lama tidak menjelaskan alurnya. Ketiga langkah ini saya
   susun dari alur penjadwalan poliklinik yang lazim, BUKAN dari
   keterangan RS.

   Yang perlu dipastikan ke bagian terkait:
     - poliklinik mana yang menangani wasir di RS JMC
     - apakah perlu rujukan
     - apakah bisa datang langsung tanpa janji

   Kalau alurnya berbeda, ubah teksnya di sini - komponennya tidak
   perlu disentuh. Kalau RS belum bisa memastikan, KOSONGKAN array
   ini; bagiannya hilang sendiri dari halaman.
   ============================================================ */
export const LANGKAH = [
  {
    judul: { id: "Hubungi Customer Service", en: "Contact Customer Service" },
    isi: {
      id: "Tanyakan jadwal dokter yang tersedia. Anda tidak perlu menjelaskan keluhan secara rinci di tahap ini.",
      en: "Ask which doctors are available. You do not need to describe your symptoms in detail at this stage.",
    },
  },
  {
    judul: { id: "Tentukan jadwal", en: "Choose a time" },
    isi: {
      id: "Petugas mengonfirmasi jadwal konsultasi beserta ketentuan dan biayanya.",
      en: "Our staff will confirm your appointment time, the requirements, and the cost.",
    },
  },
  {
    judul: { id: "Konsultasi", en: "Consultation" },
    isi: {
      id: "Dokter memeriksa kondisi Anda, lalu menjelaskan pilihan penanganan yang sesuai.",
      en: "The doctor will examine you and explain the treatment options that suit your condition.",
    },
  },
];
